import React, { useCallback, useMemo, useState } from "react";
import { graphql } from "gatsby";
import classNames from "classnames";
import FooterNewsletter from "./atoms/footer-newsletter";
import SocialIcons from "./atoms/social-icons";
import { Link } from "./atoms/link";
import Icon from "./atoms/icon";
import ChevronRight from "../icons/chevron-right.svg";
import ChevronDown from "../icons/chevron-down.svg";

const Footer = ({ data, customFooter, generatedLocale }) => {
  const [openMap, setOpenMap] = useState({});
  const toggleItem = useCallback((e) => {
    const clickedIdx = parseInt(e.target.name);
    setOpenMap((openMap) => ({ ...openMap, [clickedIdx]: !!openMap[clickedIdx] ? false : true }));
  }, []);

  const { liferayFooter, labelManagerLabels } = data;
  const defaultFooter = liferayFooter.nodes.find(
    (footer) => !footer?.isCustom && !footer?.ecommerceFooter
  );
  const footer = customFooter && customFooter?.isCustom ? customFooter : defaultFooter;

  const rowSorted = useMemo(() => {
    const filterCol = (itemCol) =>
      itemCol.otherPages.some(
        (otherPage) =>
          otherPage.child?.hasBody ||
          otherPage.child?.hasProdotti ||
          otherPage.child?.externalLink ||
          otherPage.child?.products?.length > 0 ||
          (otherPage.child?.pageLine?.length > 0 &&
            otherPage.child?.pageLine?.some((page) => page?.hasProdotti))
      ) || itemCol.columnFirstPage.columnPage;

    return footer.row
      .filter((row) => !!row?.menuRow)
      .filter((row) => row.column.some(filterCol))
      .sort((a, b) => {
        const posA = parseInt(a.rowPosition?.length ? a.rowPosition[0] : 0);
        const posB = parseInt(b.rowPosition?.length ? b.rowPosition[0] : 0);
        return !isNaN(posA) && !isNaN(posB) ? posA - posB : isNaN(posA) ? 1 : -1;
      })
      .map((item) => ({
        ...item,
        column: item.column
          .filter(filterCol)
          .map((itemCol) => ({
            ...itemCol,
            otherPages: itemCol.otherPages
              .filter(
                (otherPage) =>
                  otherPage.child?.hasBody ||
                  otherPage.child?.hasProdotti ||
                  otherPage.child?.externalLink ||
                  otherPage.child?.products?.length > 0 ||
                  (otherPage.child?.pageLine?.length > 0 &&
                    otherPage.child?.pageLine?.some((page) => page?.hasProdotti))
              )
              .sort((a, b) => {
                const posA = parseInt(a.positionOtherPage?.length ? a.positionOtherPage[0] : 0);
                const posB = parseInt(b.positionOtherPage?.length ? b.positionOtherPage[0] : 0);
                return !isNaN(posA) && !isNaN(posB) ? posA - posB : isNaN(posA) ? 1 : -1;
              }),
          }))
          .sort((a, b) => {
            const posA = parseInt(a.columnPosition?.length ? a.columnPosition[0] : 0);
            const posB = parseInt(b.columnPosition?.length ? b.columnPosition[0] : 0);
            return !isNaN(posA) && !isNaN(posB) ? posA - posB : isNaN(posA) ? 1 : -1;
          }),
      }));
  }, [footer.row]);

  return (
    <div className="footer">
      {(footer.newsletter.newsletterPage !== null ||
        (footer?.payAndSocial?.length > 0 &&
          footer?.payAndSocial?.some((item) => item?.payAndSocialIcons?.pages?.length > 0))) && (
        <div className="footer__newsletter-container">
          {footer.newsletter && footer.newsletter.newsletterPage && (
            <FooterNewsletter
              newsletter={footer.newsletter}
              labelManagerLabels={labelManagerLabels}
            />
          )}
        </div>
      )}

      <div className="footer__container">
        {rowSorted.map((item, i) => (
          <div
            key={i}
            className={classNames(
              i === 0 && "footer__first_row col-12 col-md-9",
              i === 1 && "footer__second_row col-12 col-md-9"
            )}
          >
            {item.column?.map((item2, j) => (
              <ul className="footer__ul" key={j}>
                <li key={j} className="li-footer first-position">
                  {(item2.columnFirstPage.columnPage?.slug &&
                    item2.columnFirstPage.columnPage?.hasBody) ||
                  item2.columnFirstPage.columnPage?.externalLink ||
                  item2.columnFirstPage.columnPage?.products?.length > 0 ||
                  (item2.columnFirstPage.columnPage?.pageLine?.length > 0 &&
                    item2.columnFirstPage.columnPage?.pageLine?.some(
                      (page) => page?.hasProdotti
                    )) ? (
                    <Link
                      to={
                        item2.columnFirstPage.columnPage?.slug ||
                        item2.columnFirstPage.columnPage?.externalLink ||
                        item2.columnFirstPage.columnPage?.link
                      }
                      target={item2.columnFirstPage?.targetColumnPage}
                    >
                      {item2.columnFirstPage.columnPage.pageNameInMenFooter ||
                        item2.columnFirstPage.columnPage?.title ||
                        item2.columnFirstPage.columnPage?.titleCrossLine}
                    </Link>
                  ) : (
                    item2.columnFirstPage.columnPage && (
                      <button className="footer__span first-position" name={j} onClick={toggleItem}>
                        {item2.columnFirstPage.columnPage.pageNameInMenFooter ||
                          item2.columnFirstPage.columnPage.title ||
                          item2.columnFirstPage.columnPage.titleCrossLine}
                        <ChevronDown
                          className={classNames("footer__span-chevron", openMap[j] && "open")}
                        />
                      </button>
                    )
                  )}
                </li>
                <div className={classNames("footer__list", openMap[j] && "open")}>
                  {item2.otherPages?.map((item3, z) => (
                    <li key={z} className="li-footer">
                      {item3.child?.slug || item3.child?.externalLink || item3.child?.link ? (
                        <Link
                          to={item3.child?.slug || item3.child?.externalLink || item3.child?.link}
                          target={item3.child?.targetOtherPage}
                        >
                          {item3.child?.pageNameInMenFooter ||
                            item3.child?.title ||
                            item3.child?.titleCrossLine}
                        </Link>
                      ) : null}
                      {/* <ChevronRight /> */}
                    </li>
                  ))}
                </div>
              </ul>
            ))}
          </div>
        ))}

        {footer?.payAndSocial?.length > 0 &&
          footer?.payAndSocial?.some((item) => item?.payAndSocialIcons?.pages?.length > 0) && (
            <div className="footer__pay-social col-12 col-md-3">
              {footer?.payAndSocial?.map((item, i) => (
                <SocialIcons
                  key={i}
                  socialIcons={item?.payAndSocialIcons}
                  followUs={item?.followUs}
                />
              ))}
            </div>
          )}
      </div>

      <div className="footer__info-container">
        <div className="footer__row-info">
          <div className="footer__colSxInfo-wrapper">
            <Link to="./" className="home-footer">
              {labelManagerLabels.home}
            </Link>
            <div className="footer__colSxInfo">
              <p>{footer.legalInfo}</p>
            </div>
          </div>
          <div className="footer__colDxInfo">
            <div className="info-content">
              {footer.informativePages.length &&
                footer.informativePages
                  .sort((a, b) => {
                    const posA = parseInt(
                      a.positionInformativePage?.length ? a.positionInformativePage[0] : 0
                    );
                    const posB = parseInt(
                      b.positionInformativePage?.length ? b.positionInformativePage[0] : 0
                    );
                    return !isNaN(posA) && !isNaN(posB) ? posA - posB : isNaN(posA) ? 1 : -1;
                  })
                  .map((itemInfo, iii) => (
                    <Link
                      key={iii}
                      to={
                        itemInfo.isLocale
                          ? generatedLocale || itemInfo.informativePage?.externalLink
                          : itemInfo.informativePage?.externalLink || itemInfo.informativePage?.slug
                      }
                      target={itemInfo.targetInformativePage}
                    >
                      {itemInfo.informativePage?.hooverStIcons?.alternativeIcon ||
                      itemInfo.informativePage?.hooverStIcons?.icon ? (
                        <>
                          <Icon
                            className={`icon-${itemInfo.informativePage.hooverStIcons.icon}`}
                            name={
                              itemInfo.informativePage.hooverStIcons.alternativeIcon
                                ? "custom"
                                : itemInfo.informativePage.hooverStIcons.icon
                            }
                            url={
                              itemInfo.informativePage.hooverStIcons.width ||
                              itemInfo.informativePage.hooverStIcons.height
                                ? itemInfo.informativePage.hooverStIcons.alternativeIcon?.node
                                    ?.publicURL
                                : itemInfo.informativePage.hooverStIcons.alternativeIcon?.node
                                    ?.resize?.src
                            }
                            width={itemInfo.informativePage.hooverStIcons.width}
                            height={itemInfo.informativePage.hooverStIcons.height}
                            alt={
                              itemInfo.informativePage.hooverStIcons.alternativeIcon
                                ? itemInfo.informativePage.hooverStIcons.alternativeIcon.value
                                    ?.description
                                : ""
                            }
                          />
                          {labelManagerLabels.language}
                          <ChevronRight />
                        </>
                      ) : (
                        itemInfo.informativePage?.pageNameInMenFooter ||
                        itemInfo.informativePage?.title
                      )}
                    </Link>
                  ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
export const query = graphql`
  {
    liferayFooter: allLiferayFooter {
      nodes {
        isCustom
        ecommerceFooter
        newsletter {
          errorMessage
          newsletterPage {
            ... on LiferayPage {
              id
              title
              slug
            }
          }
          placeholder
          titleNewsletterBanner
        }
        payAndSocial {
          followUs
          payAndSocialIcons {
            pages {
              hooverStPosition {
                position
              }
              hooverStTarget {
                target
              }
              page {
                ... on LiferayPageExternalLink {
                  id
                  title
                  externalLink
                  hooverStIcons {
                    icon
                    alternativeIcon {
                      node {
                        publicURL
                        resize(width: 40) {
                          src
                        }
                      }
                      value {
                        description
                      }
                    }
                    width
                    height
                  }
                }
              }
            }
          }
        }
        legalInfo
        informativePages {
          informativePage {
            ... on LiferayPageExternalLink {
              id
              title
              externalLink
              pageNameInMenFooter
              hooverStIcons {
                icon
                alternativeIcon {
                  node {
                    publicURL
                    resize(width: 40) {
                      src
                    }
                  }
                  value {
                    description
                  }
                }
                width
                height
              }
            }
            ... on LiferayPage {
              id
              title
              slug
              pageNameInMenFooter
              hooverStIcons {
                icon
                alternativeIcon {
                  node {
                    publicURL
                    resize(width: 40) {
                      src
                    }
                  }
                  value {
                    description
                  }
                }
                width
                height
              }
            }
          }
          positionInformativePage
          targetInformativePage
          isLocale
        }
        row {
          menuRow
          rowPosition
          column {
            columnPosition
            columnFirstPage {
              columnPage {
                ... on LiferayPageExternalLink {
                  id
                  title
                  externalLink
                  pageNameInMenFooter
                }
                ... on LiferayPage {
                  id
                  title
                  slug
                  hasBody
                  pageNameInMenFooter
                }
                ... on LiferayPageCrossLine {
                  id
                  titleCrossLine
                  link
                  pageNameInMenFooter
                  products {
                    id
                  }
                  pageLine {
                    ... on LiferayPageLine {
                      hasProdotti
                      lineId
                    }
                  }
                }
                ... on LiferayPageLine {
                  id
                  title
                  slug
                  hasProdotti
                  pageNameInMenFooter
                }
              }
              targetColumnPage
            }
            otherPages {
              positionOtherPage
              targetOtherPage
              child {
                ... on LiferayPage {
                  id
                  title
                  slug
                  hasBody
                  pageNameInMenFooter
                }
                ... on LiferayPageExternalLink {
                  id
                  title
                  externalLink
                  pageNameInMenFooter
                }
                ... on LiferayPageCrossLine {
                  id
                  titleCrossLine
                  link
                  products {
                    id
                  }
                  pageNameInMenFooter
                  pageLine {
                    ... on LiferayPageLine {
                      hasProdotti
                      lineId
                    }
                  }
                }
                ... on LiferayPageLine {
                  id
                  title
                  slug
                  hasProdotti
                  pageNameInMenFooter
                }
              }
            }
          }
        }
      }
    }
    labelManagerLabels: labelManagerLabels {
      subscribe
      home
      language
    }
  }
`;
